import React, { FC, useEffect, useRef, useState } from "react";
import { Paragraph } from "@tvg/design-system/web";
import { TopPool } from "@tvg/ts-types/Pool";
import { UnaryFn } from "@tvg/ts-types/Functional";
import TopPoolCard from "../TopPoolCard";
import { Container, ListContainer } from "./styled-components";

const MAX_WIDTH_BREAKPOINT = 1000;

interface TopPoolsListProps {
  title: string;
  topPools: TopPool[];
  onPoolClick: UnaryFn<TopPool, void>;
}

const TopPoolsList: FC<TopPoolsListProps> = ({
  title,
  topPools,
  onPoolClick
}) => {
  const [isOnWide, setIsOnWide] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      setIsOnWide(entries[0].contentRect.width > MAX_WIDTH_BREAKPOINT);
    });

    if (containerRef.current) resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Container ref={containerRef}>
      <Paragraph
        qaLabel={`${title}-title`}
        fontFamily="medium"
        textTransform="uppercase"
        color="--fd-colors-content-default"
        pl="space-5"
        fontSize="xs"
      >
        {title}
      </Paragraph>
      <ListContainer isOnWide={isOnWide}>
        {topPools.map((pool: TopPool, index: number) => (
          <TopPoolCard
            key={`${pool.trackCode}-${pool.amount}`}
            topPool={pool}
            index={index}
            isOnWide={isOnWide}
            onPoolClick={onPoolClick}
          />
        ))}
      </ListContainer>
    </Container>
  );
};

export default TopPoolsList;
